import React, { FC } from "react";
import { faMicrophone } from "@fortawesome/pro-solid-svg-icons/faMicrophone";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const Microphone: FC<JSX.IntrinsicAttributes> = (props) => (
  <FontAwesomeIcon icon={faMicrophone} {...props} />
);
